import { useMutation } from '@apollo/react-hooks';
import { ConsoleLogger, LoggerService } from 'logger-extension-vfs';
import React, { useEffect, useState } from 'react';
import { LogoSpinnerV } from 'react-logo-spinner-ext';
import { TermsAndConditionScreen } from './components/TermsandCondition';

import config from '../../config/default.config.json';

const console: LoggerService = new LoggerService(
  new ConsoleLogger('TermsPage:container'),
);


export const TermsandCondition = () => {

const _renderBody = () => {
//   if(loading){
//     return <LogoSpinnerV uri={'https://i.ibb.co/bWBCqc6/we-do-verify-icon.png'} />
//   }

    return <TermsAndConditionScreen />
  }    
  return <>{_renderBody()}</>;
};
